export default {
  formJSON: [],
  newField: false,
  formBackground: {},
  formContent: {
    formDescription: "",
    formTitle: "",
    fontColor: { hex: "#383838" },
    buttonTextColor: { hex: "#FFF" },
    buttonLabel: "",
    buttonBackground: { hex: "#00aeee" },
    formBackground: "",
    thankYouMessage: "",
    finalParagraph: "",
    buttonLabel2: "",
    buttonLink: "",
  },
  currentFormInfo: {},
  isLoadingForm: true,
  config: {
    key:
      "kRB4zD5D4E1G3A1G2qYFa1UQRFQIVc2MSMd1IWPNb1IFd1yD2I2D1A3C7E2F2C5E1G1==",
      attribution: false,
    zIndex: 0,
    iframe: true,
    pluginsEnabled: [
      "align",
      "charCounter",
      "codeBeautifier",
      "codeView",
      "colors",
      "draggable",
      "embedly",
      "table",
      "lists",
      "link",
      "fontSize",
      "fullscreen",
      "inlineClass",
      "lineBreaker",
      "paragraphStyle",
      "quote",
      "url",
      "wordPaste",
    ],
    iframeStyleFiles: [
      "https://cdnjs.cloudflare.com/ajax/libs/froala-editor/3.2.1/css/froala_style.min.css",
    ],
    toolbarButtons: [
      "bold",
      "italic",
      "underline",
      "clearFormatting",
      "insertLink",
      "|",
      "undo",
      "redo",
    ],
  },
  defaultData: {
    formDescription: "",
    formTitle: "",
    fontColor: { hex: "#383838" },
    buttonTextColor: { hex: "#FFF" },
    buttonLabel: "",
    buttonBackground: { hex: "#00aeee" },
    formBackground: "",
    thankYouMessage: "",
    finalParagraph: "",
    buttonLabel2: "",
    buttonLink: "",
  },
  options: {
    controlPosition: "left",
    scrollToFieldOnAdd: false,
    disabledActionButtons: ["data", "clear", "save"],
    controlOrder: [
      "radio-group",
      "checkbox-group",
      "text",
      "file",
      "date",
      "textarea",
      "number",
      "paragraph",
    ],
    disabledAttrs: [
      "className",
      "name",
      "access",
      "inline",
      "toggle",
      "other",
      "step",
    ],
    fields: [
      {
        label: "Email",
        type: "text",
        subtype: "email",
        icon: "<span class='icon appicon-email'></span>",
      },
      {
        label: "Single option",
        type: "radio-group",
        icon: "<span class='icon appicon-simple'></span>",
      },
      {
        label: "Multiple option",
        type: "checkbox-group",
        icon: "<span class='icon appicon-multiple'></span>",
      },
      {
        label: "Text Field",
        type: "text",
        icon: "<span class='icon appicon-short-text'></span>",
      },
      {
        label: "File Upload",
        type: "file",
        icon: "<span class='icon appicon-upload'></span>",
      },
      {
        label: "Date Field",
        type: "date",
        icon: "<span class='icon appicon-calendar'></span>",
      },
      {
        label: "Text Area",
        type: "textarea",
        icon: "<span class='icon appicon-long-text'></span>",
      },
      {
        label: "Number Field",
        type: "number",
        icon: "<span class='icon appicon-number'></span>",
      },
      {
        label: "Label",
        type: "paragraph",
        icon: "<span class='icon appicon-textlabel'></span>",
      },
    ],
    disabledSubtypes: {
      text: ["password", "color", "tel"],
    },
    typeUserDisabledAttrs: {
      textarea: ["subtype", "rows"],
      paragraph: ["subtype"],
      date: ["placeholder"],
      text: ["maxlength"],
      file: ["placeholder", "subtype", "help"],
    },
    typeUserAttrs: {
      text: {
        errorMessage: {
          label: "Error message",
          value: "This field is required",
        },
      },
      date: {
        errorMessage: {
          label: "Error message",
          value: "This field is required",
        },
      },
      number: {
        errorMessage: {
          label: "Error message",
          value: "This field is required",
        },
      },
      textarea: {
        errorMessage: {
          label: "Error message",
          value: "This field is required",
        },
      },
      "checkbox-group": {
        errorMessage: {
          label: "Error message",
          value: "This field is required",
        },
      },
      "radio-group": {
        errorMessage: {
          label: "Error message",
          value: "This field is required",
        },
      },
    },
  },
  currentFormCourses: [],
  currentFormUsers: [],
};
